import { COUNTER_LOCALE_ATTR, COUNTER_VALUE_ATTR } from './counter-contract'

/** Shares the report's 600-char `counters` bound; already more than any route here renders. */
const MAX_NODES = 10

/** Longest text kept per node. A counter is a number and a suffix; anything past this is not one. */
const MAX_TEXT = 24

/**
 * Pairs each counter's `data-value` and locale with the text beside it: the two numbers a production
 * React #418 refuses to name. How to read a line: docs/notes/app/frontend-error-detection.md
 *
 * Fully guarded — this runs while the DOM is in whatever state a failed hydration left it, and failing
 * to enrich a report must never cost the report.
 */
export function counterSnapshot(): string | undefined {
  if (typeof document === 'undefined') return undefined
  try {
    // Skip React's streamed-Suspense holders: they keep the SERVER's copy of a client-rendered subtree.
    const nodes = Array.from(document.querySelectorAll<HTMLElement>(`[${COUNTER_VALUE_ATTR}]`))
      .filter((el) => !el.closest('div[hidden][id^="S:"]'))
      .slice(0, MAX_NODES)
    if (nodes.length === 0) return undefined
    const shellLocale = document.documentElement.lang || '?'
    const lines = nodes.map(
      (el) =>
        `${el.getAttribute(COUNTER_LOCALE_ATTR) ?? '?'}/${el.dataset.testid || '-'}:` +
        `${el.getAttribute(COUNTER_VALUE_ATTR) ?? '?'}=>${(el.textContent ?? '').trim().slice(0, MAX_TEXT)}`,
    )
    return [`lang:${shellLocale}`, ...lines].join(' | ')
  } catch {
    return undefined
  }
}
